import { RightioWBSAPIModelsUdtUdtServiceAgreementPaymentDetailsV2 } from "@src/utilities/apis/wbs/model";
import { CCNewAPIDtoPaymentDetailsDto, CCNewAPIDtoPaymentTypeIDEnum } from "../../../apis/ccm/model";

export class ServiceAgreementPaymentDetails_v2 implements RightioWBSAPIModelsUdtUdtServiceAgreementPaymentDetailsV2 {
  constructor() {
    this.#serviceAgreementPaymentDetailsId = -1;
    this.#serviceAgreementId = -1;
    this.#serviceAgreementPaymentTypeId = 0;
    this.#serviceAgreementBillingFrequencyId = 0;
    this.#isEncrypted = true;
    this.#directDebitBankName = "";
    this.#directDebitBankProperty = undefined;
    this.#directDebitBankStreet = undefined;
    this.#directDebitBankLocality = undefined;
    this.#directDebitBankTown = undefined;
    this.#directDebitBankCounty = undefined;
    this.#directDebitBankPostcode = undefined;
    this.#directDebitEmail = undefined;
    this.#stripePaymentMethodId = undefined;
    this.#goCardlessBankAccountId = undefined;
  }

  #serviceAgreementPaymentDetailsId: number;
  #serviceAgreementId: number;
  #serviceAgreementPaymentTypeId: number;
  #serviceAgreementBillingFrequencyId: number;
  #isEncrypted: boolean;
  #directDebitBankName?: string;
  #directDebitBankProperty?: string;
  #directDebitBankStreet?: string;
  #directDebitBankLocality?: string;
  #directDebitBankTown?: string;
  #directDebitBankCounty?: string;
  #directDebitBankPostcode?: string;
  #directDebitEmail?: string;
  #stripePaymentMethodId?: string;
  #goCardlessBankAccountId?: string;

  toObject(): any {
    return {
      _serviceAgreementPaymentDetailsId: this.#serviceAgreementPaymentDetailsId,
      _serviceAgreementId: this.#serviceAgreementId,
      _serviceAgreementPaymentTypeId: this.#serviceAgreementPaymentTypeId,
      _serviceAgreementBillingFrequencyId: this.#serviceAgreementBillingFrequencyId,
      _isEncrypted: this.#isEncrypted,
      _directDebitBankName: this.#serviceAgreementPaymentTypeId === 1 ? this.#directDebitBankName : undefined,
      _directDebitBankProperty: this.#serviceAgreementPaymentTypeId === 1 ? this.#directDebitBankProperty : undefined,
      _directDebitBankStreet: this.#serviceAgreementPaymentTypeId === 1 ? this.#directDebitBankStreet : undefined,
      _directDebitBankLocality: this.#serviceAgreementPaymentTypeId === 1 ? this.#directDebitBankLocality : undefined,
      _directDebitBankTown: this.#serviceAgreementPaymentTypeId === 1 ? this.#directDebitBankTown : undefined,
      _directDebitBankCounty: this.#serviceAgreementPaymentTypeId === 1 ? this.#directDebitBankCounty : undefined,
      _directDebitBankPostcode: this.#serviceAgreementPaymentTypeId === 1 ? this.#directDebitBankPostcode : undefined,
      _directDebitEmail: this.#serviceAgreementPaymentTypeId === 1 ? this.#directDebitEmail : undefined,
      _stripePaymentMethodId: this.#serviceAgreementPaymentTypeId !== 1 ? this.#stripePaymentMethodId : undefined,
      _goCardlessBankAccountId: this.#serviceAgreementPaymentTypeId === 1 ? this.#goCardlessBankAccountId : undefined,
    };
  }

  toRequest(): CCNewAPIDtoPaymentDetailsDto {
    return {
      // serviceAgreementPaymentDetailsId: this.#serviceAgreementPaymentDetailsId,
      serviceAgreementId: this.#serviceAgreementId,
      serviceAgreementPaymentTypeId: this.#converToEnum(this.#serviceAgreementPaymentTypeId),
      serviceAgreementBillingFrequencyId: this.#serviceAgreementBillingFrequencyId,
      directDebitBankName: this.#serviceAgreementPaymentTypeId === 1 ? this.#directDebitBankName : undefined,
      stripePaymentMethodId: this.#serviceAgreementPaymentTypeId !== 1 ? this.#stripePaymentMethodId : undefined,
      goCardlessBankAccountId: this.#serviceAgreementPaymentTypeId === 1 ? this.#goCardlessBankAccountId : undefined
    };
  }

  #converToEnum(value: number): CCNewAPIDtoPaymentTypeIDEnum {
    switch (value) {
      case 1:
        return CCNewAPIDtoPaymentTypeIDEnum.direct_debit;
      case 2:
        return CCNewAPIDtoPaymentTypeIDEnum.credit_card;
      case 3:
        return CCNewAPIDtoPaymentTypeIDEnum.debit_card;
      case 4:
        return CCNewAPIDtoPaymentTypeIDEnum.cheque;
      case 5:
        return CCNewAPIDtoPaymentTypeIDEnum.standing_order;
      default:
        throw new Error(`Unknown value ${value}`);
    }
  }

  public get serviceAgreementPaymentDetailsId(): number {
    return this.#serviceAgreementPaymentDetailsId;
  }

  public set serviceAgreementPaymentDetailsId(serviceAgreementPaymentDetailsId: number) {
    this.#serviceAgreementPaymentDetailsId = serviceAgreementPaymentDetailsId;
  }

  public get serviceAgreementId(): number {
    return this.#serviceAgreementId;
  }

  public set serviceAgreementId(serviceAgreementId: number) {
    this.#serviceAgreementId = serviceAgreementId;
  }

  public get serviceAgreementPaymentTypeId(): number {
    return this.#serviceAgreementPaymentTypeId;
  }

  public set serviceAgreementPaymentTypeId(serviceAgreementPaymentTypeId: number) {
    this.#serviceAgreementPaymentTypeId = serviceAgreementPaymentTypeId;
  }

  public get serviceAgreementBillingFrequencyId(): number {
    return this.#serviceAgreementBillingFrequencyId;
  }

  public set serviceAgreementBillingFrequencyId(serviceAgreementBillingFrequencyId: number) {
    this.#serviceAgreementBillingFrequencyId = serviceAgreementBillingFrequencyId;
  }

  public get isEncrypted(): boolean {
    return this.#isEncrypted;
  }

  public set isEncrypted(isEncrypted: boolean) {
    this.#isEncrypted = isEncrypted;
  }

  public get directDebitBankName(): string | undefined {
    return this.#directDebitBankName;
  }

  public set directDebitBankName(directDebitBankName: string | undefined) {
    this.#directDebitBankName = directDebitBankName;
  }

  public get directDebitBankProperty(): string | undefined {
    return this.#directDebitBankProperty;
  }

  public set directDebitBankProperty(directDebitBankProperty: string | undefined) {
    this.#directDebitBankProperty = directDebitBankProperty;
  }

  public get directDebitBankStreet(): string | undefined {
    return this.#directDebitBankStreet;
  }

  public set directDebitBankStreet(directDebitBankStreet: string | undefined) {
    this.#directDebitBankStreet = directDebitBankStreet;
  }

  public get directDebitBankLocality(): string | undefined {
    return this.#directDebitBankLocality;
  }

  public set directDebitBankLocality(directDebitBankLocality: string | undefined) {
    this.#directDebitBankLocality = directDebitBankLocality;
  }

  public get directDebitBankTown(): string | undefined {
    return this.#directDebitBankTown;
  }

  public set directDebitBankTown(directDebitBankTown: string | undefined) {
    this.#directDebitBankTown = directDebitBankTown;
  }

  public get directDebitBankCounty(): string | undefined {
    return this.#directDebitBankCounty;
  }

  public set directDebitBankCounty(directDebitBankCounty: string | undefined) {
    this.#directDebitBankCounty = directDebitBankCounty;
  }

  public get directDebitBankPostcode(): string | undefined {
    return this.#directDebitBankPostcode;
  }

  public set directDebitBankPostcode(directDebitBankPostcode: string | undefined) {
    this.#directDebitBankPostcode = directDebitBankPostcode;
  }

  public get directDebitEmail(): string | undefined {
    return this.#directDebitEmail;
  }

  public set directDebitEmail(directDebitEmail: string | undefined) {
    this.#directDebitEmail = directDebitEmail;
  }

  public get stripePaymentMethodId(): string | undefined {
    return this.#stripePaymentMethodId;
  }

  public set stripePaymentMethodId(stripePaymentMethodId: string | undefined) {
    this.#stripePaymentMethodId = stripePaymentMethodId;
  }

  public get goCardlessBankAccountId(): string | undefined {
    return this.#goCardlessBankAccountId;
  }

  public set goCardlessBankAccountId(goCardlessBankAccountId: string | undefined) {
    this.#goCardlessBankAccountId = goCardlessBankAccountId;
  }
}
